let clientModifiers = null;

try {
  clientModifiers = require('@ExternalClientModifiers');
} catch (e) {
  // silent
}

const defaults = {
  replaceAppComponent: ({ state }) => null,
  enhanceApp: ({ DefaultApp, state }) => DefaultApp,
  modifyClientRouterParams: ({isFragment}) => ({}),
};

const isFn = (fn) => typeof fn === 'function';

export const getClientModifiers = () => {
  if (clientModifiers && typeof clientModifiers === 'function') {
    const { replaceAppComponent, enhanceApp, modifyClientRouterParams } = clientModifiers();

    return {
      ...defaults,
      ...(isFn(replaceAppComponent) && { replaceAppComponent }),
      ...(isFn(modifyClientRouterParams) && { modifyClientRouterParams }),
      ...(isFn(enhanceApp) && { enhanceApp }),
    };
  }

  return defaults;
};
